import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RefreshableResult } from '@mastechnicaegroup/carelinelive-cdk/rx';
import { ClientSingleResponse } from '@lib/api/models/client';
import { AsyncPipe } from '@angular/common';
import { ButtonsModule, CardModule, IconModule } from '@mastechnicaegroup/carelinelive-ui';
import { ErrorPanelComponent } from '@lib/errors/error-panel/error-panel.component';
import { ComponentsModule } from '@mastechnicaegroup/carelinelive-ui';
import { AccordionItemComponent } from '@shared/layout/accordion-item/accordion-item.component';

@Component({
    selector: 'app-client-comments',
    imports: [
        AsyncPipe,
        CardModule,
        ButtonsModule,
        IconModule,
        ErrorPanelComponent,
        ComponentsModule,
        AccordionItemComponent
    ],
    templateUrl: './client-additional-comments.component.html',
    standalone: true,
    styleUrl: './client-additional-comments.component.scss'
})
export class ClientAdditionalCommentsComponent {

    @Input() clientData: RefreshableResult<ClientSingleResponse> | undefined;
    @Output() editAdditionalCommentsEvent: EventEmitter<void> = new EventEmitter<void>();

    editAdditionalComments() {
        window.scrollTo(0, 0);
        this.editAdditionalCommentsEvent.emit();
    }
}
